import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import LandingPage from "./pages/LandingPage/LandingPage";
import CompanyPage from "./pages/CompanyPage/CompanyPage";
import NotFoundPage from "./pages/NotFoundPage/NotFoundPage";
import PrivacyPage from "./pages/PrivacyPage/PrivacyPage";
import DownloadPage from "./pages/DownloadPage/DownloadPage";
import Footer from "./components/Footer/Footer";
import TwitterConvTrkr from "react-twitter-conversion-tracker";

import usePageTracking from "./usePageTracking";

import "./App.css";

function App() {
  TwitterConvTrkr.init("o7ro8");
  TwitterConvTrkr.pageView();
  usePageTracking();
  return (
    <Router>
      <Switch>
        <Route path="/" exact component={LandingPage} />
        <Route path="/company" exact component={CompanyPage} />
        <Route path="/privacy" exact component={PrivacyPage} />
        <Route path="/download" exact component={DownloadPage} />
        <Route path="*" exact component={NotFoundPage} />
      </Switch>
      <Footer />
    </Router>
  );
}

export default App;
